import { LoaderCircle } from "lucide-react";

export function PageLoading({ message }: { message: string }) {
  return (
    <div className="fe-page-state" role="status" aria-live="polite">
      <div className="fe-page-state-icon"><LoaderCircle className="animate-spin" aria-hidden="true" /></div>
      <p className="font-semibold">{message}</p>
      <p className="text-sm text-gray-600">잠시만 기다려 주세요.</p>
    </div>
  );
}
